// React
import React from "react";
// Transitions
import ReactRouteTransition from "common/ui/containers/routeTransitionWrapper/ReactRouteTransition";
import * as utils from "common/ui/containers/routeTransitionWrapper/utils";
export class ReportsTransitionWrapper extends React.Component {
    render() {
        return (React.createElement(ReactRouteTransition, { isRelativeContainer: false, pathname: utils.slicePathAtLevel(this.props.location, 4) }, this.props.children));
    }
}
export class SubReportsTransitionWrapper extends React.Component {
    render() {
        return (React.createElement(ReactRouteTransition, { isRelativeContainer: true, pathname: utils.slicePathAtLevel(this.props.location, 5) }, this.props.children));
    }
}
